import { showDeliveryZones } from '@/event/order/showDeliveryZones'

export function toggleShowDeliveryZones() {
  showDeliveryZones.value = !showDeliveryZones.value

  if (showDeliveryZones.value === true) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
}
